import Vue from "vue";
import VueI18n from "vue-i18n";
// 引入语言文件
// Miracle项目
import zh_CN from "./MUI/Miracle/zh"; // 中文
import zh_TW from "./MUI/Miracle/zhTW"; // 繁体
import en from "./MUI/Miracle/en";
import ko from "./MUI/Miracle/ko";
import ja from "./MUI/Miracle/ja";


Vue.use(VueI18n);


const messages = {
  zh_CN,
  zh_TW,
  en,
  ko,
  ja,

};

const i18n = new VueI18n({
  // 实例化VueI18n
  locale: localStorage.getItem("SET_LANGUAGE") || "zh_CN", // 默认英语、开发使用中文
  messages: messages, // 语言包
  silentTranslationWarn: true, // 去掉翻译警告
});

export default i18n;
